import React from 'react';
import { List, Typography, Spin, Empty, Card } from 'antd';
import { FireOutlined, ReloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styles from '@/assets/styles/History.module.less';

const { Text } = Typography;

export interface TrendingItem {
  query: string;
  useCount: number;
  latestAt?: Date | string;
}

interface TrendingListProps {
  title: string;
  data: TrendingItem[];
  loading: boolean;
  onRefresh: () => void;
}

const TrendingList: React.FC<TrendingListProps> = ({
  title,
  data,
  loading,
  onRefresh,
}) => {
  const navigate = useNavigate();

  const handleItemClick = (query: string) => {
    navigate(`/dictionary?query=${encodeURIComponent(query)}`);
  };

  return (
    <Card
      title={
        <span>
          <FireOutlined /> {title}
        </span>
      }
      extra={
        <ReloadOutlined
          onClick={onRefresh}
          style={{ cursor: 'pointer' }}
          title="刷新"
        />
      }
      className={styles.trendingCard}
    >
      {loading ? (
        <div className={styles.spinContainer}>
          <Spin />
        </div>
      ) : data.length === 0 ? (
        <Empty description="暂无数据" />
      ) : (
        <List
          dataSource={data}
          renderItem={(item) => (
            <List.Item
              className={styles.trendingItem}
              onClick={() => handleItemClick(item.query)}
            >
              <div className={styles.itemContent}>
                <Text strong className={styles.query}>
                  {item.query}
                </Text>
                <Text type="secondary" className={styles.useCount}>
                  {item.useCount} 次
                </Text>
              </div>
            </List.Item>
          )}
        />
      )}
    </Card>
  );
};

export default TrendingList;
